import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import CopyIcon from "@redotech/redo-icons/copy-01.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Text } from "@redotech/redo-web/text";
import * as styles from "./return-tracking-number-column.module.css";

const catalogEntry = fgColumnEntries.returnTrackingNumber;

export const ReturnTrackingNumberColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  width: catalogEntry.defaultWidth,
  renderNormalCell: ({ row }) => {
    const trackingCodes = row.returnTrackingCodes;
    if (!trackingCodes?.length) {
      return null;
    }
    return (
      <Flex align="center" gap="sm" pl="lg">
        {trackingCodes.map(({ code, link }) => (
          <Text
            className={styles.link}
            color="secondary"
            fontSize="xs"
            key={code}
            onClick={() => {
              window.open(link, "_blank");
            }}
          >
            {`#${code}`}
          </Text>
        ))}
        <RedoButton
          aria-label="Copy"
          IconLeading={CopyIcon}
          onClick={async () => {
            await navigator.clipboard.writeText(
              trackingCodes.map(({ code }) => code).join(", "),
            );
          }}
          size="xs"
        />
      </Flex>
    );
  },
  alignment: ColumnAlignment.LEFT,
};
